import axios from "axios";

import config from "../../../config";
import dealsService from "../../../services/dealsService";

const resolveServerData = (serverRes) => serverRes.data || { err: "Problem with the request" };

export const getHaklaiDealData = (dealId) => dealsService.getDealData(dealId);

export const updateHaklaiDealData = (dealId, calc, manage, isDealDateChanged) => (
  axios.post(config.updateDealDataEndpoint, { dealId, calc, manage, isDealDateChanged }).then(resolveServerData)
);

export const analyzeHaklaiDeal = (dealId) => (
  axios.post(config.haklaiAnalyzeEndpoint, { dealId }).then(resolveServerData)
);

export const getHaklaiDeductionTypeOptions = () => dealsService.getDeductionTypeOptions();
